import React, { useEffect, useState } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button, Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CatPagination from '../../../../Website/utils/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { exportScheduleOrderThunk, getAllScheduleOrderThunk, setSchedulePage, setScheduleStatus } from '../../../../Website/redux/scheduleOrderSlice';
import { exportDataExcel, formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '13px',
    color: '#475569',
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    height: '36px',
    fontWeight: '600',
    padding: '0 14px',
    fontFamily: 'inherit',
    '&:hover': {
        backgroundColor: '#f8fafc',
        borderColor: '#cbd5e1',
    },
}));

const statuss = ['NEW', 'APPROVED', 'COMPLETED', "PENDING", "AWAITING", "RESCHEDULE", "CANCELLED", "DISPATCHED"];

const CuScheduletable = () => {
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(25);
    const { scheduleOrder, page, loading, status } = useSelector(state => state.scheduleOrder);
    const data = scheduleOrder?.data;
    const totalPages = scheduleOrder?.totalPages;
    const totalItems = scheduleOrder?.totalItems;
    const itemsPerPage = scheduleOrder?.limit;
    const navigate = useNavigate();
    const [exportLoading, setExportLoading] = useState(false);

    const start = (page - 1) * limit + 1;
    const end = totalPages === page ? totalItems : (page - 1) * limit + limit;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (statusVal) => {
        if (statusVal !== undefined && typeof statusVal === 'string') {
            dispatch(setScheduleStatus(statusVal));
        }
        setAnchorEl(null);
    };

    useEffect(() => {
        dispatch(getAllScheduleOrderThunk(`?page=${page}&limit=${limit}&status=${status}`));
    }, [page, limit, status, dispatch]);

    const exportbomenq = async () => {
        setExportLoading(true);
        const statusRes = await dispatch(exportScheduleOrderThunk(`?limit=${1000000000000000}`));
        setExportLoading(false);

        if (statusRes?.payload?.success === true) {
            const exportOrderData = statusRes?.payload?.data;
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'createdBy': item?.user?.fullName,
                'products': (item?.partList?.length || 0) + ' products',
                'Scheduled period': item?.period,
                'Status': item?.status || '-',
                'CreatedAt': formateDate(item?.createdAt),
            }));

            exportDataExcel(exportdata, "ScheduleEnquiries");
        }
    };

    const renderStatusBadge = (statusVal) => {
        const s = (statusVal || '').toUpperCase();
        let label = statusVal;
        let bg = '#f1f5f9';
        let color = '#475569';

        if (s === 'NEW') {
            label = 'Under Approval';
            bg = 'rgba(245, 158, 11, 0.1)';
            color = '#d97706';
        } else if (s === 'APPROVED') {
            label = 'In Progress';
            bg = 'rgba(59, 130, 246, 0.1)';
            color = '#2563eb';
        } else if (s === 'AWAITING') {
            label = 'Awaiting Dispatch';
            bg = 'rgba(245, 158, 11, 0.1)';
            color = '#d97706';
        } else if (s === 'COMPLETED') {
            label = 'Completed';
            bg = 'rgba(16, 185, 129, 0.1)';
            color = '#10b981';
        } else if (s === 'DISPATCHED') {
            label = 'Dispatched';
            bg = 'rgba(16, 185, 129, 0.1)';
            color = '#10b981';
        } else if (s === 'CANCELLED' || s === 'CANCELED') {
            label = 'Cancelled';
            bg = 'rgba(239, 68, 68, 0.1)';
            color = '#ef4444';
        } else if (s === 'PENDING') {
            label = 'Pending';
            bg = 'rgba(245, 158, 11, 0.1)';
            color = '#d97706';
        }

        return (
            <span style={{
                backgroundColor: bg,
                color: color,
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '600',
                display: 'inline-block'
            }}>
                {label}
            </span>
        );
    };

    return (
        <Paper sx={{ width: '100%', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', overflow: 'hidden', border: '1px solid #f1f5f9' }}>
            {/* Header Bar */}
            <Box sx={{ padding: '24px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafafa', borderBottom: '1px solid #f1f5f9', flexWrap: 'wrap', gap: '16px' }}>
                <Box>
                    <Typography sx={{ fontSize: "20px", color: '#0f172a', fontWeight: '700', fontFamily: 'inherit' }}>
                        Scheduled PO
                    </Typography>
                    <Typography sx={{ fontSize: "13px", color: '#64748b', marginTop: '2px' }}>
                        Track and manage your scheduled purchase orders and delivery timelines.
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div>
                        <ActionButton onClick={handleClick}>
                            <Filter /> <span style={{ marginLeft: '6px' }}>{status ? status : "Filters"}</span>
                        </ActionButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleClose()}
                            PaperProps={{
                                elevation: 3,
                                sx: { borderRadius: '8px', marginTop: '4px' }
                            }}
                        >
                            <MenuItem onClick={() => handleClose('')} sx={{ fontSize: '13px', color: '#64748b' }}>All Statuses</MenuItem>
                            {statuss.map((i) => (
                                <MenuItem key={i} onClick={() => handleClose(i)} sx={{ fontSize: '13px', color: '#0f172a', fontWeight: '500' }}>
                                    {i}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>

                    <Button
                        onClick={exportbomenq}
                        disabled={exportLoading}
                        variant="contained"
                        size="small"
                        sx={{
                            background: '#512DA8',
                            color: '#ffffff',
                            borderRadius: '8px',
                            textTransform: 'none',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '6px 16px',
                            height: '36px',
                            boxShadow: 'none',
                            '&:hover': {
                                background: '#4527a0',
                                boxShadow: '0 4px 12px rgba(81, 45, 168, 0.2)'
                            }
                        }}
                    >
                        <Download /> <span style={{ marginLeft: '6px' }}>{exportLoading ? "Please wait..." : "Download"}</span>
                    </Button>
                </Box>
            </Box>

            {/* Content Body */}
            <Box sx={{ padding: '24px 30px' }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '60px 0' }}>
                        <img src="/assets/__Iphone-spinner-1.gif" alt="loading" style={{ width: 35, height: 35 }} />
                    </Box>
                ) : (
                    <>
                        {data?.length > 0 ? (
                            <>
                                <table className={styles.spectable}>
                                    <thead>
                                        <tr>
                                            <th>PO ID</th>
                                            <th>Order Date</th>
                                            <th>Scheduled period</th>
                                            <th>No of items</th>
                                            <th>Order Status</th>
                                            <th style={{ textAlign: 'right' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className={styles.spectbody}>
                                        {data?.map((record) => (
                                            <tr key={record._id || record.id}>
                                                <td style={{ fontWeight: '600', color: '#0f172a' }}>
                                                    #{record._id} {record?.userId?.fullName ? `(${record.userId.fullName})` : ''}
                                                </td>
                                                <td style={{ color: '#64748b' }}>{formateDate(record?.createdAt)}</td>
                                                <td style={{ fontWeight: '500', color: '#0f172a' }}>{record?.period} months</td>
                                                <td style={{ color: '#64748b' }}>{record?.products?.length || 0} items</td>
                                                <td>
                                                    {renderStatusBadge(record.status)}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <Button
                                                        size="small"
                                                        onClick={() => navigate(`/schedulePoDetails/${record?._id}`)}
                                                        sx={{
                                                            color: '#512DA8',
                                                            textTransform: 'none',
                                                            fontWeight: '600',
                                                            fontSize: '12px',
                                                            borderRadius: '6px',
                                                            '&:hover': {
                                                                background: 'rgba(81, 45, 168, 0.06)'
                                                            }
                                                        }}
                                                    >
                                                        View Details
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Box sx={{ marginTop: '20px' }}>
                                    <CatPagination
                                        totalItems={totalItems}
                                        itemsPerPage={itemsPerPage}
                                        start={start}
                                        end={end}
                                        page={page}
                                        setPage={setSchedulePage}
                                    />
                                </Box>
                            </>
                        ) : (
                            <Box sx={{ padding: '60px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                    </svg>
                                </div>
                                <Typography sx={{ fontSize: '15px', color: '#0f172a', fontWeight: '600' }}>
                                    No Scheduled POs Found
                                </Typography>
                                <Typography sx={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                                    There are no scheduled purchase order records to display at this time.
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </Paper>
    );
};

export default CuScheduletable;
